import {Section, SelectAllMechanism} from 'common/components/items-menu/types';
import {ButtonSize} from 'common/components/button/constants';
import {DataGroup} from 'common/widgets/data-group-selector/types';
import {Segmentation} from 'common/types/reports/query';
import {CountUsersOnceState, PropertyType} from 'common/report/constants';
import {Directions} from 'common/components/drop-menu/types';
import {RollingWindowSize} from 'common/util';
import {TooltipReact} from 'common/components/tooltip';
import {DatePickerMode} from 'common/widgets/date-range-picker-new/util';
import {Translatable} from 'common/i18n';
import {ChartType, MetricType} from 'common/types/reports/bookmark';

import {AdvancedMenuValue} from '../query-entry-section/types';
import * as PropertiesMenu from './properties-menu/types';
import {QueryBlockTheme, SelectorType} from './constants';
import {PropertySectionItem} from './properties-menu/item-menu-types';
import {IncludeCustomPropertyType} from './properties-menu/types';

export enum MenuType {
  Behaviors = `behaviors`,
  Breakdown = `breakdown`,
  Events = `events`,
  Formulas = `formulas`,
  SavedMetrics = `savedMetrics`,
  Filter = `filter`,
  Properties = `properties`,
  MultiEvents = `multi-events`,
}

// todo: audit which ones should be required
export type QueryBlockParams = {
  elref?: string;
  className?: string;
  tabIndex?: number;

  type?: MenuType;
  allDataGroups?: boolean;
  allowBehavioralPropertyCreation?: boolean;
  allowTypecastPillAction?: PropertiesMenu.TypecastPillAction;
  applyButtonText?: string;
  highlightSelections?: boolean;
  metricType?: MetricType;
  minSelection?: number;
  autofocus?: boolean;
  chartType?: ChartType;
  dataGroupId?: string;
  /** dataGroupIds supersedes dataGroupId to support metric-level data groups (vs a single global data group) */
  dataGroupIds?: Set<string | null>;
  metricLevelDataGroups?: boolean;
  enableAllDataGroupsForScdProps?: boolean;
  disableAllScdProps?: boolean;
  // for time menu to show "on" on the header tabs
  // default to [InTheLast, Between, Since] in date-range-picker
  datePickerModesOption?: DatePickerMode[];
  dataGroups?: DataGroup[];
  dateRange?: any; // {type: `json`, description: `Only for time-comparison menu type`},
  dateUnit?: RollingWindowSize;
  disabled?: boolean;
  disabledItems?: any;
  displayContext?: string;
  enableEnhancedListFilters?: boolean;
  enableWorkspaceFilterRestrictions?: boolean;
  disableValueSelection?: boolean;
  excludeAutotrackEvents?: boolean;
  excludeCustomEvents?: boolean;
  // this is used in events page to avoid removing required columns
  excludeClearProperties?: string[];
  includeCustomProperties?: IncludeCustomPropertyType;
  showBorrowedProperties?: boolean;
  excludeDimensionProperties?: boolean;
  excludeLookupTableProperties?: boolean;
  excludedElements?: any; // {type: `json`, default: []},
  eventNames?: any; // {type: `json`, default: null},
  headerSegments?: any; // `json`,
  headerText?: string;
  helpText?: Translatable;
  inputOnly?: boolean;
  tooltip?: React.ComponentProps<typeof TooltipReact>;
  isBlockedPeople?: boolean;
  label?: Translatable;
  maxDataHistoryDays?: number;
  cohortMultiselect?: boolean;
  multiple?: boolean;
  open?: boolean;
  prefixLabel?: string;
  suffixLabel?: string;
  propertyCombineMode?: string; // {type: `string`, default: null},
  hideEvents?: boolean;
  hideExperiments?: boolean;
  hideAllPropertiesSelect?: boolean;
  projectHasPeople?: boolean;
  projectHasCohorts?: boolean;
  projectId?: number;
  projectIsFreePlan?: boolean;
  readonly?: boolean;
  removable?: boolean;
  selected?: TODO; // PropertiesMenu.Selection; // {type: `json`, default: null},
  inverted?: boolean;
  includeHidden?: boolean;
  selectorIcon?: string;
  selectorRightIcon?: string;
  selectorType?: SelectorType;
  showAnyEvent?: boolean;
  showSessionEvent?: boolean;
  showAllEvents?: boolean;
  showAllTab?: boolean;
  specialCohorts?: Obj[];
  showTopEvents?: boolean;
  supportB2bCohorts?: boolean;
  inlineCohortsOverride?: any; // `json`,
  isMultiAttribution?: boolean;
  hideEditControls?: boolean;
  showSpecialDatePropertyUnit?: boolean;
  showSpecialDatasetProperty?: boolean;
  theme?: QueryBlockTheme;
  buttonSize?: ButtonSize;
  tabs?: any; //`json`,
  trackName?: string;
  otherGroupByOptions?: Array<PropertySectionItem<string>>;
  otherFilterOptions?: Array<PropertySectionItem<string>>;
  otherAggregationOptions?: Array<PropertySectionItem<string>>;
  preventClose?: boolean;
  userId?: number;
  workspaceId?: number;
  projectAsOfDate?: string;
  searchPlaceholder?: string;
  showSelectAll?: boolean;
  selectAllMechanism?: SelectAllMechanism;
  selectAllDisabled?: boolean;
  hideRecentlyViewed?: boolean;
  selectableSensitiveProperties?: boolean;
  menuItemTypes?: Array<PropertiesMenu.MenuItemType>; // json,
  menuAlignment?: Directions;
  contextPanelAlignment?: Directions;
  menuOffset?: number;
  typeFilter?: PropertyType[];

  // advanced sections (currently only consumed in count-menu)
  advancedMenuSections?: Array<Section<AdvancedMenuValue>>;
  countUsersOnceState?: CountUsersOnceState; // also only applies to count-menu

  labelRenderer?: () => React.ReactNode;
  listProperty?: Segmentation;
  getSortedMenuSections?: PropertiesMenu.GetSortedMenuSections;

  contextPanelParentElement?: HTMLElement;

  onSelect?: (detail: any) => void;
  onSelectAll?: (detail: any) => void;
  onSelectHeaderItem?: (item: any) => void;
  onOpen?: () => void;
  onClose?: () => void;
  onRemove?: () => void;
  onCreate?: (ev: CustomEvent) => void;

  // todo: no good reason for this component to emit a click event
  onClick?: () => void;

  // propagated events from down unda
  onTrack?: (ev: CustomEvent) => void;
  onSavedCustomEvent?: (ev: CustomEvent) => void;
};
